import {createApp} from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

//引入ajax
import {ajax} from "@/utils/ajax.js";

// vant
import Vant from "vant";
import "vant/lib/index.css";


//rem适配
import "amfe-flexible";

//全局样式表
import "@/assets/global.css";

//rem适配
import 'amfe-flexible'
// import Toast from "vant";


let app = createApp(App);


app.config.globalProperties.$ajax = ajax;


app.use(router);
app.use(Vant);
app.use(store);

// app.use(Toast);
// app.use(DatePicker);
// app.use(vant.Lazyload);

app.mount("#app");
